export default __webpack_public_path__ + "static/media/regulatory--width-limit--g1.e94fb0a5.png";